 <template>
  <div v-show="!cookie" class="cookie-consent">
    <div class="msg container">      
      <div class="cookie-terms">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Our website uses cookies and similar technologies to provide you with a better service while searching or placing an order, for analytical purposes and to personalise our advertising to you.
        <div class="cookie-term-link">
          You can change your cookie settings by reading our <router-link to="/cookie_policy" class="link-understand">cookie policy</router-link>. Otherwise, we’ll assume you’re OK with our use of cookies.
        </div>
      </div>
      <div class="cookie-btn-box"><div class="cookie-accept"  v-on:click="setCookies()"><i class="fa fa-check" aria-hidden="true"></i>OK, I understand</div></div>
    </div>
  </div>
</template>

<style src="./../MyProfile.component.css" scoped>
</style>

<style>
.cookie-consent {
    font-size: 12px;
    padding: 10px 10px 10px 0;
    color: #fff;
    background-color: #333;
    display: block;
}
.cookie-btn-box {
  text-align: right;
}
.msg {
    font-size: 14px;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    max-width: 1200px;
    padding: 20px 40px 10px 40px;
    position: relative;
}    
.cookie-consent .fa-info-circle {
    font-size: 30px;   
    left: 0; 
    position: absolute;
}
.cookie-consent .cookie-terms {
    display: inline-block;
    max-width: 700px;
    padding-left: 20px;
    vertical-align: top;
    border-left: 1px solid #fff;
    width: 100%;
    margin-bottom: 15px;
}
.cookie-consent .cookie-accept {
    position: relative;
    display: inline-block;
    max-width: 170px;
    padding: 5px 10px;
    text-align: center;
    background-color: #31ce31;
    border-radius: 5px 5px 5px 5px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    cursor: pointer;
}
.cookie-consent .cookie-accept .fa-check {
  margin-right: 10px;
}
.link-understand {
  color: #7fb069;
}


</style>

<script>
export default {
  name: "WidgetCookie",
  props: {   
  },
  data() {
    return {
      cookie: false
    }    
  },
  methods: {
    setCookies() {
       console.log("SET cookies >>>>>>>>>>>>>>>>>>>>>>>" + this.cookie)

      this.$cookies.set("greeneum.net", "true");
      this.cookie = true;
    },
  },
  async created() {
    try {
      if (!this.$cookies.get("greeneum.net")){
        console.log("NO cookies >>>>>>>>>>>>>>>>>>>>>>>")        
      }
      else {
        this.cookie = true;
      }
    } catch (error) {
      console.error(error)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/MyProfile/Widget/Cookie.vue